import {
  Box,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormHelperText,
  FormControlLabel,
  InputLabel,
  TextField,
  Tabs,
  Tab,
  Typography,
  MobileStepper,
  Alert,
  Stepper,
  Step,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import axios from "axios";
import { useSetRecoilState } from "recoil";
import { useCallback, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { topTitleState } from "recoil/common/index";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { rem } from "assets/js/common";
import { useParams } from "react-router-dom";
import Step1 from "components/join/step1";
import Step2 from "components/join/step2";
import Step3 from "components/join/step3";

const useStyles = makeStyles((theme) => ({
  joinWrap: {
    display: "flex",
    flexDirection: "column",

    "& .MuiStepper-root": {
      height: rem(8),
      "& .MuiStep-root": {
        width: rem(8),
        height: rem(8),
        flex: "none",
        padding: 0,
        backgroundColor: theme.palette.info.light,
        borderRadius: "50%",
        "&.Mui-completed": {
          backgroundColor: theme.palette.primary.main,
        },
        "& + .MuiStep-root": {
          marginLeft: rem(8),
        },
      },
    },
    "& .form": {
      flex: 1,
      height: "100%",
      paddingTop: 0,
      "& form": {
        height: "100%",
      },
    },
    "& .layout-flex": {
      height: "calc(100vh - 120px)",
      paddingTop: 0,
    },
  },
}));

export default function Join(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { seq } = useParams();

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "회원가입", menu: false }));
  }, [init]);

  return (
    <main id="main" className={"container nopad " + classes.joinWrap}>
      <Box className="box-type-1">
        <Stepper
          activeStep={Number(seq)}
          alternativeLabel
          className={classes.joinStep}
        >
          {Array.from(Array(3)).map((_, index) => (
            <Step key={index} />
          ))}
        </Stepper>
      </Box>
      {/* <Step1 /> */}
      <Box className="form">
        {seq == 1 ? <Step1 /> : seq == 2 ? <Step2 /> : <Step3 />}
      </Box>
    </main>
  );
}
